import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-article-card--skeleton__link" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "c-article-card--skeleton__image" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "c-article-card--skeleton__title" }, " "),
    /*#__PURE__*/_createElementVNode("div", { class: "c-article-card--skeleton__date" }, " ")
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-article-card--skeleton", _ctx.isTwoColumns ? 'c-article-card--skeleton--two-columns' : ''])
  }, _hoisted_2, 2))
}